// DS: i4.55
import React from 'react';
import IconWrap, { Props } from '../../IconWrap';

const MailOutline: React.FC<Props> = props => (
  <IconWrap {...props}>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="currentColor"
        d="M4.5 8.25367V6H19.5V8.2573L12.0555 11.6048L4.5 8.25367ZM3.7 4C3.03727 4 2.5 4.53725 2.5 5.2V9.55449L11.5712 13.5779C11.883 13.7162 12.2388 13.7153 12.5499 13.5754L21.5 9.55087V5.2C21.5 4.53726 20.9627 4 20.3 4H3.7ZM4.5 13.2C4.5 12.6477 4.05228 12.2 3.5 12.2C2.94772 12.2 2.5 12.6477 2.5 13.2V20H21.5V13.2C21.5 12.6477 21.0523 12.2 20.5 12.2C19.9477 12.2 19.5 12.6477 19.5 13.2V18H4.5V13.2Z"
      />
    </svg>
  </IconWrap>
);
MailOutline.displayName = 'MailOutline';

export default MailOutline;
